<template>

  <div class="flex flex-col justify-center bg-black bg-cover bg-center bg-no-repeat">
    <HomeTopBar />

    <div class="place-content-center self-center max-w-[1300px]">

      <div class="flex flex-col mt-20">

        <div class="relative overflow-visible ">
          <div class="relative z-20 mt-1 text-6xl text-white font-semibold text-whitemax-md:mt-10 max-md:text-4xl">
            产品
          </div>

          <!-- 背景图片 -->
          <img src="/images/bg/xsrec.png" class="absolute top-0 left-0 w-full h-full transform scale-[3.5] z-10"
            alt="background-image" />
        </div>
      </div>
    </div>

    <!-- 以下是产品 -->
    <div class="relative self-center mt-24 w-10/12 max-md:mt-10 max-md:max-w-full ">
      <img src="/images/bg/halfcir.png" class="absolute top-0 left-0 w-full h-full transform scale-[1.2] z-10"
        alt="background-image" />

      <div class="relative z-20 grid grid-rows-1 grid-cols-2 place-content-center gap-10">
        <div>
          <router-link to="/products">
            <div class=" relative pt-20 whitespace-nowrap rounded-2xl border-2 border-white border-solid max-w-[800px]
              max-md:mt-10 max-md:max-w-full">
              <img loading="lazy" src="/images/shili1.png" class="object-cover absolute inset-0 size-full" />
              <div class="relative px-16 py-9 mt-32 text-5xl font-semibold text-white rounded-none 
                max-md:px-5 max-md:py-4 max-md:mt-10 max-md:mt-24 max-md:text-3xl max-md:max-w-full">
                芯片代理
              </div>
            </div>
          </router-link>
        </div>
        <div>
          <div class=" relative pt-20 whitespace-nowrap rounded-2xl border-2 border-white border-solid max-w-[800px]
              max-md:mt-10 max-md:max-w-full">
            <img loading="lazy" src="/images/shili2.png" class="object-cover absolute inset-0 size-full" />
            <div class="relative px-16 py-9 mt-32 text-5xl font-semibold text-white rounded-none 
                 max-md:px-5 max-md:py-4 max-md:mt-10 max-md:mt-24 max-md:text-3xl max-md:max-w-full">
              模组方案
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 以下是多场景应用 -->
    <div class="relative overflow-x-clip">
      <div class="self-center mt-60 w-full mx-auto max-w-[1052px] max-md:mt-10 max-md:max-w-full">
        <img src="/images/bg/lrec.png" class="absolute -top-28 max-md:-top-20 left-0  transform scale-[1.2] z-10"
          alt="background-image" />

        <div class="relative flex gap-5 z-20 max-md:flex-col">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col self-stretch px-5 my-auto text-white max-md:mt-10">
              <div
                class="ml-6 self-start text-6xl text-left font-semibold max-lg:text-5xl max-md:text-4xl max-md:self-center">
                多场景应用
              </div>
              <div class="mt-10 text-4xl font-light text-left break-words max-md:mx-20">
                嵌入式指纹适用于多场景，全方位解决难题。
              </div>
            </div>
          </div>
          <!-- 场景应用的右侧图片 -->>
          <div class="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div class="grid grid-cols-2 gap-4 md:gap-12 max-md:grid-cols-1 max-md:mt-10 max-md:max-w-full">
              <div
                class="flex flex-col items-center px-5 text-4xl font-light text-white whitespace-nowrap max-md:mt-10">
                <img loading="lazy" srcSet="/images/chanpin1.png"
                  class="w-48 rounded-full border-indigo-300 border-solid aspect-square border-[3px]" />
                <div class="mt-9">指纹门锁</div>
              </div>
              <div
                class="flex flex-col items-center px-5 text-4xl font-light text-white whitespace-nowrap max-md:mt-10">
                <img loading="lazy" srcSet="/images/chanpin2.png"
                  class="w-48 rounded-full border-indigo-300 border-solid aspect-square border-[3px]" />
                <div class="mt-9">笔记本电脑</div>
              </div>
              <div
                class="flex flex-col items-center px-5 text-4xl font-light text-white whitespace-nowrap max-md:mt-10">
                <img loading="lazy" srcSet="/images/chanpin3.png"
                  class="w-48 rounded-full border-indigo-300 border-solid aspect-square border-[3px]" />
                <div class="mt-9">指纹箱包锁</div>
              </div>
              <div
                class="flex flex-col items-center px-5 text-4xl font-light text-white whitespace-nowrap max-md:mt-10">
                <img loading="lazy" srcSet="/images/chanpin4.png"
                  class="w-48 rounded-full border-indigo-300 border-solid aspect-square border-[3px]" />
                <div class="mt-9">指纹鼠标</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 以下是合作品牌 -->

    <div class="place-content-center self-center max-w-[1300px]">

      <div class="flex flex-col mt-48">
        <div class="relative overflow-visible">
          <img src="/images/bg/srec.png" class="absolute top-0 left-0 w-full h-full transform scale-[2] z-10"
            alt="background-image" />
          <div class="relative text-6xl text-center font-semibold text-white max-md:text-4xl z-20">
            合作品牌
          </div>
        </div>
      </div>
    </div>


    <div class="relative">
      <img src="/images/bg/vec.png" class="absolute top-20 max-md:top-10 w-full z-10" alt="background-image" />

      <div class="relative ml-[25%] mr-[25%] mb-[15%] flex gap-[20%] justify-center items-center z-20">

        <img loading="lazy" src="/images/friends/yale.png"
          class="mt-20 w-2/12 relative shadow-[0px_4px_10px_rgba(255,239,239,0.49)] max-md:mt-10 max-md:max-w-full" />
        <img loading="lazy" src="/images/friends/yunding.png"
          class="mt-20 w-2/12 relative shadow-[0px_4px_10px_rgba(255,239,239,0.49)] max-md:mt-10 max-md:max-w-full" />
        <img loading="lazy" src="/images/friends/voc.png"
          class="mt-20 w-2/12 relative shadow-[0px_4px_10px_rgba(255,239,239,0.49)] max-md:mt-10 max-md:max-w-full" />
        <img loading="lazy" src="/images/friends/anker.png"
          class="mt-20 w-2/12 relative shadow-[0px_4px_10px_rgba(255,239,239,0.49)] max-md:mt-10 max-md:max-w-full" />
        <img loading="lazy" src="/images/friends/xiaomi.png"
          class="mt-20 w-2/12 relative shadow-[0px_4px_10px_rgba(255,239,239,0.49)] max-md:mt-10 max-md:max-w-full" />

      </div>
    </div>
  </div>
</template>

<script>
import HomeTopBar from '@/components/HomeTopBar.vue';

export default {
  name: 'HomePage',
  components: {
    HomeTopBar,
  },
};
</script>
